import React, { useState } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { palette, theme as colorTheme } from "../../../Convoze.theme";



const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;
const secondary = colorTheme('palette', 'secondary').value
const night = colorTheme('palette', 'night').value



const UsageTrendChart = ({ trendData = [], title }) => {
  const [view, setView] = useState("monthly"); // default view

  // --- Monthly data ---
  const monthlyMinutes = trendData.map((d) => d.totalMinutes || 0);
  const monthlyCost = trendData.map((d) => d.totalCost || 0);
  const daysInMonth = trendData.map((d) => d.day);

  // --- Weekly (last 7 days with weekdays) ---
  const weeklyDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const last7 = trendData.slice(-7); // last 7 entries
  const weeklyMinutes = last7.map((d) => d.totalMinutes || 0);
  const weeklyCost = last7.map((d) => d.totalCost || 0);

  // --- Weekly (weeks of month: Week 1, Week 2...) ---
  const weekChunks = [];
  for (let i = 0; i < trendData.length; i += 7) {
    const week = trendData.slice(i, i + 7);
    weekChunks.push({
      minutes: week.reduce((sum, d) => sum + (d.totalMinutes || 0), 0),
      cost: week.reduce((sum, d) => sum + (d.totalCost || 0), 0),
    });
  }
  const weeklyLabels = weekChunks.map((_, i) => `Week ${i + 1}`);
  const weeklyByWeekMinutes = weekChunks.map((w) => w.minutes);
  const weeklyByWeekCost = weekChunks.map((w) => w.cost);

  // --- Switch between views ---
  const getXAxis = () => {
    if (view === "weekly-days") return weeklyDays;
    if (view === "weekly-weeks") return weeklyLabels;
    return daysInMonth; // monthly
  };

  const getMinutes = () => {
    if (view === "weekly-days") return weeklyMinutes;
    if (view === "weekly-weeks") return weeklyByWeekMinutes;
    return monthlyMinutes;
  };

  const getCost = () => {
    if (view === "weekly-days") return weeklyCost;
    if (view === "weekly-weeks") return weeklyByWeekCost;
    return monthlyCost;
  };

  const option = {
    title: {
      text: title || `Usage Trend (${view})`,
      left: "left",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    legend: {
      bottom: 10,
      left: "center",
      orient: "horizontal",
    },
    grid: {
      top: 60,
      right: 20,
      bottom: 60,
      left: 50,
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: getXAxis(),
      axisLabel: {
        rotate: view === "monthly" ? 45 : 0,
        fontSize: 10,
      },
    },
    yAxis: { type: "value", min: 0 },
    series: [
      {
        name: "Minutes Used",
        type: "bar",
        data: getMinutes(),
        itemStyle:
        //  { color: "#6366F1" },
        {color : primary},
        label: { show: true, position: "top" },
        barWidth: view === "monthly" ? 13 : 30,
      },
      {
        name: "Cost",
        type: "line",
        data: getCost(),
        itemStyle: {
          //  color: "#FFBF00" 
          color : neutral,
          },
        smooth: true,
      },
    ],
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Top-right buttons */}
      <div style={{ position: "absolute", top: 0, right: 0, zIndex: 10 }}>
        {["weekly-days", "weekly-weeks", "monthly"].map((v) => (
          <button
            key={v}
            onClick={() => setView(v)}
            style={{
              marginLeft: 5,
              padding: "4px 10px",
              borderRadius: "6px",
              border: view === v ? `1px solid ${colorTheme('palette', 'primary').value}` : "1px solid #ccc",
              background: view === v ? `${colorTheme('palette', 'primary').value}}` : "#fff",
              color:night,
              cursor: "pointer",
            }}
          >
            {v === "weekly-days"
              ? "Weekly (Days)"
              : v === "weekly-weeks"
              ? "Weekly (Weeks)"
              : "Monthly"}
          </button>
        ))}
      </div>

      <ReactECharts
        option={option}
        style={{ height: "450px", width: "100%" }}
        echarts={echarts}
      />
    </div>
  );
};

export default UsageTrendChart;

// import React, { useState, useEffect } from "react";
// import ReactECharts from "echarts-for-react";
// import * as echarts from "echarts";

// const UsageTrendChart = ({ trendData, title }) => {
//   const data = [
//     ["2025-08-01", 120, 300],
//     ["2025-08-02", 200, 500],
//     ["2025-08-03", 150, 400],
//     ["2025-08-04", 80, 200],
//     ["2025-08-05", 70, 180],
//     ["2025-08-06", 110, 350],
//     ["2025-08-07", 130, 250],
//   ];

//   const option = {
//     tooltip: {
//       position: "top",
//       formatter: (p) => {
//         const [date, minutes, cost] = p.data;
//         return `
//           <b>${date}</b><br/>
//           Minutes: ${minutes}<br/>
//           Cost: ₹${cost}
//         `;
//       },
//     },
//     visualMap: {
//       min: 0,
//       max: 300,
//       calculable: true,
//       orient: "horizontal",
//       left: "center",
//       bottom: 20,
//       inRange: {
//         color: ["#e0f2fe", "#6366F1"],
//       },
//       text: ["High", "Low"],
//     },
//     calendar: {
//       range: "2025-08",
//       cellSize: ["auto", 40],
//       splitLine: {
//         show: true,
//         lineStyle: {
//           color: "#ddd",
//           width: 1,
//         },
//       },
//       dayLabel: {
//         firstDay: 1,
//         nameMap: "en",
//       },
//       monthLabel: {
//         nameMap: "en",
//       },
//     },
//     series: [
//       {
//         type: "heatmap",
//         coordinateSystem: "calendar",
//         data: data,
//       },
//     ],
//   };
//   return (
//     <ReactECharts
//       option={option}
//       style={{ height: "100%", width: "100%" }}
//       echarts={echarts}
//     />
//   );
// };

// export default UsageTrendChart;
